import { CursorType } from "../lib/runescape/CursorType";
export var CTRIcon;
(function (CTRIcon) {
    CTRIcon.all = [
        { id: "ability-surge", name: "Surge", file_name: "surge.png", size_on_map: { x: 20, y: 20 } },
        { id: "ability-escape", name: "Escape", file_name: "escape.png", size_on_map: { x: 20, y: 20 } },
        { id: "ability-barge", name: "Barge", file_name: "barge.png", size_on_map: { x: 20, y: 20 } },
        { id: "ability-dive-combined", name: "(Bladed) Dive", file_name: "dive.png", size_on_map: { x: 20, y: 20 } },
        { id: "notes", name: "Note", file_name: "notes.png", size_on_map: { x: 20, y: 20 } },
        { id: "run", name: "Run", file_name: "run.png", size_on_map: { x: 20, y: 20 } },
        { id: "item/fetch-casket", name: "Fetch Casket", file_name: "fetch_casket.png", size_on_map: { x: 20, y: 20 } },
        { id: "item/meerkats", name: "Meerkats Pouch", file_name: "Meerkats_pouch.png", size_on_map: { x: 20, y: 20 } },
        { id: "item/spade", name: "Spade", file_name: "spade.webp", size_on_map: { x: 20, y: 20 } },
        { id: "item/powerburst-of-acceleration", name: "Powerburst of Acceleration", file_name: "accel.png", size_on_map: { x: 18, y: 24 } },
        { id: "item/rotten-potato", name: "Rotten Potato", file_name: "Rotten_potato.png", size_on_map: { x: 20, y: 20 } },
        { id: "item/decorated_fire_urn", name: "Decorated Fire Urn", file_name: "decorated_fire_urn.png", size_on_map: { x: 20, y: 19 } },
        { id: "item/sara_brew", name: "Saradomin brew (3)", file_name: "sara_brew.png", size_on_map: { x: 14, y: 20 } },
        { id: "item/zammy_brew", name: "Zamorak brew (3)", file_name: "zammy_brew.png", size_on_map: { x: 14, y: 20 } },
        { id: "item/magic_logs", name: "Magic Logs", file_name: "magic_logs.png", size_on_map: { x: 22, y: 18 } },
        { id: "item/elder_logs", name: "Elder Logs", file_name: "elder_logs.png", size_on_map: { x: 22, y: 18 } },
        { id: "spell/bake_pie", name: "Bake Pie", file_name: "bake_pie.webp", size_on_map: { x: 20, y: 20 } },
        { id: "item/black_dhide_body", name: "Black dragonhide body", file_name: "black_dhide_body.webp", size_on_map: { x: 20, y: 19 } },
        { id: "item/combatdummymk2", name: "Combat dummy MKII", file_name: "Combat_dummy_MKII.webp", size_on_map: { x: 22, y: 31 } },
        { id: "item/globetrotter_jacket", name: "Globetrotter Jacket", file_name: "Globetrotter_jacket.webp", size_on_map: { x: 27, y: 24 } },
        { id: "item/globetrotter_backpack", name: "Globetrotter Backpack", file_name: "Globetrotter_backpack.webp", size_on_map: { x: 25, y: 23 } },
        ...CursorType.all().map(c => ({ id: `cursor/${c.type}`, name: c.description, file_name: `${c.short_icon}.png`, size_on_map: { x: 28, y: 31 } }))
    ];
    const map = Object.fromEntries(CTRIcon.all.map(e => [e.id, e]));
    function search_term(icon) {
        const list = [];
        list.push(icon.file_name.split(".")[0]);
        list.push(icon.id);
        if (icon.search_term)
            list.push(icon.search_term);
        return list.join("");
    }
    CTRIcon.search_term = search_term;
    function url(icon) {
        return `assets/icons/${icon.file_name}`;
    }
    CTRIcon.url = url;
    function get(id) {
        return map[id];
    }
    CTRIcon.get = get;
})(CTRIcon || (CTRIcon = {}));
